import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Import styled components
import { Container, Wrapper, OuterWrapper, Buttons } from './styles';
import ProfileButton from 'components/views/user/common/ProfileButton';

import FieldContent from './FieldContent';

// Import helpers
import useUserAgent from 'components/utilities/hooks/user_agent/useUserAgent';
import { useFileUploader } from './useFileUploader';

function FileUploader({
	onSubmit,
	inProgress,
	placeholder,
	maxFiles,
	acceptedTypes
}) {
	const { t } = useTranslation();
	const config = {
		placeholder,
		maxFiles,
		acceptedTypes
	};
	const { isMobile } = useUserAgent();
	const {
		file,
		submit,
		rootProps,
		inputProps,
		shadowName,
		open,
		isSubmitting
	} = useFileUploader({
		onSubmit,
		inProgress,
		config
	});

	return (
		<OuterWrapper>
			<Wrapper>
				<Container {...rootProps}>
					<input {...inputProps} />
					<FieldContent
						placeholder={shadowName}
						title={file?.name}
						inProgress={inProgress}
					/>
				</Container>
				{!isMobile && (
					<ProfileButton
						disabled={inProgress || isSubmitting}
						onClick={open}
						width="9.4rem"
						height="3.9rem"
					>
						{t('user_profile_document_upload_append')}
					</ProfileButton>
				)}
			</Wrapper>
			<Buttons>
				{isMobile && (
					<ProfileButton
						disabled={inProgress || isSubmitting}
						onClick={open}
						width="9.4rem"
						height="3.9rem"
					>
						{t('user_profile_document_upload_append')}
					</ProfileButton>
				)}
				<ProfileButton
					onClick={submit}
					disabled={inProgress || !file || isSubmitting}
					isLoading={isSubmitting}
					width="9.4rem"
					height="3.9rem"
				>
					{t('common_form_submit_btn')}
				</ProfileButton>
			</Buttons>
		</OuterWrapper>
	);
}

FileUploader.defaultProps = {
	placeholder: 'PDF, JPG, PNG',
	acceptedTypes: ['image/jpeg', 'image/png', 'application/pdf'],
	maxFiles: 1
};

FileUploader.propTypes = {
	handleFileUpload: PropTypes.func.isRequired,
	inProgress: PropTypes.bool.isRequired,
	placeholder: PropTypes.string,
	acceptedTypes: PropTypes.arrayOf(PropTypes.string),
	maxFiles: PropTypes.number
};

export default FileUploader;
